module.exports = __webpack_public_path__ + "img/priscilla-logo.230a794e.svg";